import UIkit from 'uikit/dist/js/uikit-core';

const initIconCardsV2 = () => {
  const modals = document.querySelectorAll('.icon-cards-v2__modal');

  if (!modals.length) {
    return;
  }

  modals.forEach((modal) => {
    // A fixed position modal is trapped by any ancestor with a transform,
    // filter or containment, so move it out to the body before it is opened.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const video = modal.querySelector('.icon-cards-v2__video');

    if (!video) {
      return;
    }

    UIkit.util.on(modal, 'shown', () => {
      video.play().catch(() => {
        // Autoplay can be blocked, the controls are still available.
      });
    });

    // Leave the popup silent and back at the start for the next open.
    UIkit.util.on(modal, 'hide', () => {
      video.pause();
      video.currentTime = 0;
    });
  });

  document.querySelectorAll('[data-video-modal]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();

      const modalId = trigger.getAttribute('data-video-modal');
      const modal = modalId ? document.getElementById(modalId) : null;

      if (modal) {
        UIkit.modal(modal).show();
      }
    });
  });
};

export default initIconCardsV2;
